import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCompressPdf24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#F43F3F" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.667 13.481v1.63c0 1.245 0 1.867-.242 2.342a2.22 2.22 0 0 1-.972.971c-.475.243-1.097.243-2.342.243h-1.63M10.52 5.333h-1.63c-1.245 0-1.867 0-2.342.242a2.22 2.22 0 0 0-.971.972c-.242.475-.242 1.097-.242 2.342v1.63M5.334 18.667 9.5 14.5m0 0H5.334m4.166 0v4.167M18.667 5.333 14.5 9.5m0 0h4.166m-4.166 0V5.333"
    />
  </svg>
);
export default SvgCompressPdf24;
